import { Container, Loader, Stack } from '@mantine/core';
import React, { Suspense } from 'react';
import { Outlet } from 'react-router-dom';

export const EmptyLayout: React.FC = () => (
  <>
    <Suspense
      fallback={(
        <Container>
          <Stack
            mih="100vh"
            py={50}
            justify="center"
            align="center"
          >
            <Loader size="sm" color="gray" />
          </Stack>
        </Container>
      )}
    >
      <Outlet />
    </Suspense>
  </>
);
